import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { RoomReadModel } from '@client/api';
import { getBuildingId, isDefinedNumber, isDefinedString, TableCell, TableRow, Text, toNumberString } from '@client/toolkit';

import { PortfolioPaths } from '../../../../../portfolio.router';

interface ResidentialUnitRoomItemProps {
  room?: RoomReadModel;
  isFetching?: boolean;
}

export function ResidentialUnitRoomItem({
  room,
  isFetching
}: ResidentialUnitRoomItemProps) {
  const { t: tType } = useTranslation('type');

  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (!room?.id) return;

    const buildingId = getBuildingId(room.path);

    navigate(
      generatePath(PortfolioPaths.Space, { buildingId: buildingId, spaceId: room.id, discriminator: room.discriminator }),
      { replace: true }
    );
  }, [room?.id, room?.path, room?.discriminator, navigate]);

  return (
    <TableRow onClick={handleClick} hover>
      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(room?.name)}>
          <strong className="whitespace-nowrap">{room?.name}</strong>
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(room?.name)}>{tType(`RoomType.${room?.type}`)}</Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedNumber(room?.area?.metric)}>
          {toNumberString(room?.area?.metric ?? undefined, undefined, {
            unit: tType('AreaMeasurementUnit.SquareMeters', { context: 'short' }),
          })}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(room?.description)}>{room?.description}</Text>
      </TableCell>
    </TableRow>
  );
}
